export default function R_IfElse() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_IfElse Component</h1>
      <p>This is the R_IfElse tutorial section.</p>
    </div>
  );
}
